import { Component } from '@angular/core';

@Component({
  selector: 'pivot-footer',
  styleUrls: ['./footer.component.scss'],
  template: ``,
})
export class FooterComponent {
}
